<template>
  <v-data-table
    v-model="selectedUsers"
    :headers="
      headers.map((h) => ({
        ...h,
        text: $t(`CERTIFICATE.tableHeaders.${h.text}`),
      }))
    "
    :items="isFiltered ? filteredUsers : users"
    :single-select="singleSelect"
    :search="search"
    :item-class="itemRowStyle"
    show-select
    class="elevation-1 pa-8 pt-0"
  >
    <template v-slot:top>
      <v-row align="center">
        <v-text-field
          v-model="search"
          :label="$t('CERTIFICATE.searchLabel')"
          class="mx-4"
          :prepend-inner-icon="icon.mdiMagnify"
        ></v-text-field>
        <v-menu rounded="b-xl" offset-y :close-on-content-click="false">
          <template v-slot:activator="{ attrs, on }">
            <v-btn v-bind="attrs" v-on="on" class="px-10" text>
              {{ $t(`CERTIFICATE.userRoles.title`) }}
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-for="(item, i) in roles" :key="i" link>
              <v-list-item-action>
                <v-checkbox :value="item" v-model="selectedRoles"></v-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>{{
                  $t(`CERTIFICATE.userRoles.${item}`)
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </template>

    <template v-slot:[`item.data-table-select`]="{ select, item }">
      <v-checkbox
        v-model="item.isSelected"
        :disabled="isParticipant && !userHasParticipation(item)"
        :value="item.isSelected"
        @change="select($event)"
      />
    </template>

    <template v-slot:[`item.eventsRegistered`]="{ item }">
      <v-badge
        :content="userEventsAmount(item)[0].toString() || '0'"
        :color="userHasParticipation(item) ? 'blue' : 'grey'"
      ></v-badge>
    </template>

    <template v-slot:[`item.eventsParticipated`]="{ item }">
      <v-badge
        :content="userEventsAmount(item)[1].toString() || '0'"
        :color="userHasParticipation(item) ? 'green' : 'grey'"
      ></v-badge>
    </template>

    <template v-slot:[`item.roles`]="{ item }">
      {{
        item.roles
          .map((role) => $t(`CERTIFICATE.userRoles.${role}`))
          .toString()
          .split(",")
          .join(", ")
      }}
    </template>
  </v-data-table>
</template>

<script>
import { mdiMagnify } from "@mdi/js";

export default {
  data() {
    return {
      icon: {
        mdiMagnify,
      },
      search: "",
      headers: this.isParticipant ? [
        {
          text: "name",
          value: "displayName",
        },
        {
          text: "email",
          value: "email",
        },
        {
          text: "er",
          value: "eventsRegistered",
          align: "center"
        },
        {
          text: "ep",
          value: "eventsParticipated",
          align: "center"
        },
        {
          text: "roles",
          value: "roles",
          filterable: false,
        },
      ] : [
        {
          text: "name",
          value: "displayName",
        },
        {
          text: "email",
          value: "email",
        },
        {
          text: "roles",
          value: "roles",
          filterable: false,
        },
      ],
      roles: ["pa", "sa", "ta", "ea", "res", "rev"],
      selectedRoles: [],
      selectedUsers: [],
    };
  },
  props: {
    singleSelect: Boolean,
    isParticipant: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    users() {
      return (this.$store.getters.getUsers || [])
        .map(u => ({
          ...u,
          eventsRegistered: this.userEventsAmount(u)[0],
          eventsParticipated: this.userEventsAmount(u)[1],
          isSelectable: !this.isParticipant || this.userHasParticipation(u),
          isSelected: this.selectedUsers.map(su => su.displayName).includes(u.displayName),
        }))
        // eslint-disable-next-line no-constant-condition
        .sort((u1, u2) => u1.displayName != null ? u1.displayName.toLowerCase() : '' < u2.displayName != null ? u2.displayName.toLowerCase() : '' ? -1 : 1);
    },
    filteredUsers() {
      return this.filteredItems().sort((u1, u2) => u1.displayName.toLowerCase() < u2.displayName.toLowerCase() ? -1 : 1);
    },
    isFiltered() {
      return this.selectedRoles.length > 0;
    }
  },
  methods: {
    filteredItems() {
      let result = [];

      if (this.selectedRoles.length != 0) {
        this.selectedRoles.forEach((role) => {
          this.users.forEach((user) => {
            if (user.roles.includes(role)) {
              if (!result.includes(user)) result.push(user);
            }
          });
        });
        return result;
      } else {
        return this.users;
      }
    },
    itemRowStyle(item) {
      return this.isParticipant && !this.userHasParticipation(item) ? 'item-disabled' : '';
    },
    userHasParticipation(user) {
      if (!user.events || Object.keys(user.events).length === 0) return false;

      for (let eventId in user.events) {
        if (user.events[eventId]) return true;
      }

      return false;
    },
    userEventsAmount(user) {
      if (!user.events || Object.keys(user.events).length === 0) return [0, 0];

      const amount = [Object.keys(user.events).length, 0];

      for (let eventId in user.events) {
        if (user.events[eventId]) {
          amount[1] += 1;
        }
      }

      return amount;
    }
  },
  watch: {
    selectedUsers(val) {
      this.$emit("setSelectedUsers", val);
    }
  },
  created() {
    this.users;
  },
};
</script>

<style>
  .item-disabled {
    color: #888;
  }
</style>
